module.exports = __webpack_public_path__ + "static/media/M1-14-Santuário-dos-Monólitos-Rúnicos-cod113.d552942d.png";